import { createContext } from "react";
const SessionTokenContext = createContext({
  propsToken: void 0,
  source: void 0,
  token: void 0
});
export {
  SessionTokenContext
};
//# sourceMappingURL=SessionTokenContext.js.map
